import React from 'react';
import { useTranslation } from 'react-i18next';
import { Control, Controller } from 'react-hook-form';
import { SkeletonLine } from 'components/theme/Skeleton';
import { STATUS_FAILURE } from 'types/app';
import { SessionSidebarBlock, SidebarSubtitle, DimmedText } from './styles';
import RadioWrapperItem from './sub-components/RadioWrapper';

interface SessionTime {
  isDisabled: boolean;
  startTime: string;
  duration: string;
}

interface Duration {
  value: string;
  label: string;
}

interface SessionTimeSelectorProps {
  control: Control;
  durations: Duration[];
  experienceStartTimes: SessionTime[];
  fetchFirstAvailabilityStatus: string;
  isFetchingSessionTiers: boolean;
  isUnavailable: boolean;
  setSelectedStartTime: (startTime: string) => void;
  clearErrors: (name?: string) => void;
}

const SessionTimeSelector: React.FC<SessionTimeSelectorProps> = ({
  control,
  durations,
  experienceStartTimes,
  fetchFirstAvailabilityStatus,
  isFetchingSessionTiers,
  isUnavailable,
  setSelectedStartTime,
  clearErrors,
}) => {
  const { t: translate } = useTranslation();

  const defaultStartTime = experienceStartTimes?.find(
    (startTime) => !startTime.isDisabled,
  )?.startTime;

  return (
    <SessionSidebarBlock>
      <SidebarSubtitle
        id="start-time-label"
        className="experience-view-sidebar-help"
      >
        {durations.length > 0
          ? translate('selectStartTime')
          : translate('selectSession')}
        :
      </SidebarSubtitle>
      {experienceStartTimes?.length && !isUnavailable ? (
        <Controller
          control={control}
          name="sessionTime"
          rules={{ required: true }}
          defaultValue={defaultStartTime}
          render={({ field }) => {
            return (
              <RadioWrapperItem
                sessionTimes={experienceStartTimes}
                value={field.value}
                name={field.name}
                labelId="start-time-label"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setSelectedStartTime(event.target.value);
                  field.onChange(event.target.value);
                  clearErrors('sessionTime');
                }}
              />
            );
          }}
        />
      ) : (
        (isFetchingSessionTiers &&
          fetchFirstAvailabilityStatus !== STATUS_FAILURE && (
            <SkeletonLine style={{ height: '48px' }} />
          )) || <DimmedText>{translate('noAvailability')}</DimmedText>
      )}
    </SessionSidebarBlock>
  );
};

export default SessionTimeSelector;
